/** @jsx jsx */
import type { ReactNode } from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { jsx } from '@balance-web/core';
import { useTheme } from '@balance-web/theme';
import { ChevronRightIcon } from '@balance-web/icon';

import { useTestId } from '../context';
import type { ItemBaseProps, ItemSelectionProps } from '../ItemBase';
import { ItemBase } from '../ItemBase';

import { useItemStyles } from './shared-styles';

type SubMenuTriggerProps = {
  children: ReactNode;
} & ItemSelectionProps &
  Omit<ItemBaseProps, 'href' | 'target' | 'endElement'>;

export const SubMenuTrigger = ({ children, ...props }: SubMenuTriggerProps) => {
  const { semantic } = useTheme();
  const itemStyles = useItemStyles();

  const triggerStyles = {
    '&[data-state="open"]': {
      backgroundColor: semantic.colour.neutral.container.interactions.hover,
    },
  };

  const parentTestId = useTestId();
  const triggerTestIdProp = parentTestId
    ? { 'data-testid': `${parentTestId}-trigger` }
    : {};

  return (
    <DropdownMenuPrimitive.SubTrigger
      css={{ ...triggerStyles, ...itemStyles }}
      disabled={props.disabled}
      {...triggerTestIdProp}
    >
      <ItemBase
        {...props}
        endElement={
          <ChevronRightIcon
            color={props.disabled ? 'textDisabled' : 'textPrimary'}
            size="small"
          />
        }
      >
        {children}
      </ItemBase>
    </DropdownMenuPrimitive.SubTrigger>
  );
};
